import React from 'react';
import styled from 'styled-components';
import { Text } from '../../components/common/Texts';
import { randomGreeting } from '../../helpers/randomGreeting';
import CoursesTeacher from '../../components/templates/teacher/courses/Courses';
import Qualification from '../../components/templates/teacher/qualification/Qualification';
import MessagesTeacher from '../../components/templates/teacher/messages/MessagesTeacher';
import { useSelector } from 'react-redux';
import { titleHTML } from '../../helpers/title.helper';
import Binnacle from '../../components/common/teacher-academic/Binnacle';
import ErrorBoundary from '../../utils/ErrorBoundary';
import MessagesTeacherErrorFallback from './dashboard/MessagesTeacherErrorFallback';
import LibraryCard from '../../components/templates/teacher/banner/LibraryCard';
import AdenEvents from '../../components/templates/campus/AdenEvents';
import Carousel from 'react-elastic-carousel';
import { useRef } from 'react';
import NewFiltersCard from '../../components/templates/teacher/banner/NewFiltersCard';

const Dashboard = () => {
    titleHTML('Dashboard');

    const { user } = useSelector((state) => state.auth);
    const carouselRef = useRef(null);

    const capitalize = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return (
        <MainWrapper>
            {/* Bienvenida fuera del dashboard  */}
            <Welcome>
                <Greetings>
                    <Text fontSize="1.5rem" fontWeight="700">
                        ¡{randomGreeting()}{' '}
                        {capitalize(user.name.split(' ')[0])}!
                    </Text>
                    <Text fontSize="1rem" fontWeight="600">
                        Este es tu espacio para gestionar clases, revisar
                        entregas y estar al tanto de las novedades de tus
                        alumnos.{' '}
                        <strong>
                            ¡Esperamos que tengas una excelente jornada de
                            enseñanza!
                        </strong>
                    </Text>
                </Greetings>
            </Welcome>

            {/* Dashboard */}
            <DashboardWrapper>
                <DashboardTop>
                    {/* Contenido del lado izquierdo del dashboard */}
                    <LeftSideContent>
                        {/* Carousel de banners */}
                        <CarouselWrapper>
                            <StyledCarousel
                                ref={carouselRef}
                                itemsToShow={1}
                                showArrows={false}
                                pagination={true}
                                enableAutoPlay={true}
                                autoPlaySpeed={5000}
                            >
                                {/* Banner 1: Tarjeta de ir a la biblioteca */}
                                <LibraryCard />
                                {/* Banner 2: Tarjeta de ir a los filtros */}
                                <NewFiltersCard />
                            </StyledCarousel>
                        </CarouselWrapper>
                        {/* Contenido de mensajes y noticias */}
                        <MessagesAndNewsWrapper>
                            <ErrorBoundary
                                fallback={<MessagesTeacherErrorFallback />}
                            >
                                {/* Componente de mensajes */}
                                <MessagesTeacher id={user.partner_id} />
                            </ErrorBoundary>
                            {/* Componente de novedades (notificaciones) */}
                            <Binnacle />
                        </MessagesAndNewsWrapper>
                    </LeftSideContent>
                    {/* Contenido del lado derecho del dashboard */}
                    <RightSideContent>
                        {/* Componente de eventos */}
                        <AdenEvents />
                    </RightSideContent>
                </DashboardTop>

                {/* Componente de cursos */}
                <CoursesTeacher />
            </DashboardWrapper>
        </MainWrapper>
    );
};

export default Dashboard;

const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-bottom: 1rem;
    width: 100%;
`;

const CarouselWrapper = styled.div`
    width: 100%;
    position: relative;
`;

// const DashboardWrapper = styled.div`
//     display: grid;
//     gap: 1.5rem;
//     grid-template-columns: 1fr 1fr 1fr;
//     grid-template-rows: 420px auto;
//     grid-template-areas:
//         'messages actions actions'
//         'courses  courses       courses      ';
//     @media (max-width: 768px) {
//         display: flex;
//         flex-direction: column;
//     }
// `;

const DashboardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
`;

const DashboardTop = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    width: 100%;

    @media (max-width: 1200px) {
        gap: 1rem;
    }

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

const LeftSideContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    @media (max-width: 1200px) {
        gap: 2.5rem;
    }
`;

const StyledCarousel = styled(Carousel)`
    .rec.rec-arrow {
        display: none;
        visibility: hidden;
    }

    .rec.rec-slider-container {
        width: 100% !important;
        margin: 0 !important;
        box-sizing: border-box !important;
    }

    .rec.rec-pagination {
        position: absolute;
        bottom: -25px;
        left: 50%;
        transform: translateX(-50%);
    }

    .rec.rec-dot {
        background-color: #d9d9d9;
        box-shadow: none;
        width: 14px;
        height: 14px;
        &.rec.rec-dot_active {
            background-color: #b31d15;
        }
    }
`;

const MessagesAndNewsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    width: 100%;

    @media (max-width: 1200px) {
        gap: 1rem;
    }

    @media (max-width: 992px) {
        flex-direction: column;
    }

    > div {
        @media (min-width: 993px) and (max-width: 1400px) {
            &:first-child {
                max-width: 50px;
            }
        }
    }
`;

const RightSideContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 28%;
    min-width: 280px;

    @media (max-width: 1400px) {
        width: 35%;
    }

    @media (max-width: 1200px) {
        width: 100%;
        height: 600px;
    }
`;

const Welcome = styled.div`
    display: grid;
    grid-area: messages;
    grid-template-rows: auto 1fr;
    row-gap: 1rem;
`;

const Greetings = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
`;
